import { render } from "./ValetBandTable.vue?vue&type=template&id=b6fabd46&scoped=true"
import script from "./ValetBandTable.vue?vue&type=script&lang=js"
export * from "./ValetBandTable.vue?vue&type=script&lang=js"

import "./ValetBandTable.vue?vue&type=style&index=0&id=b6fabd46&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6fabd46"]])

export default __exports__